import dynamic from 'next/dynamic';
import { COMPONENT_PREFIX } from '../constants';

const addPageBuilderComponents = addComponent => {
  const components = {
    addtocart: dynamic(() =>
      import(/* webpackChunkName: "blazePbAddToCart" */ '../components/AddToCart')
    ),
    addresslist: dynamic(() =>
      import(/* webpackChunkName: "blazePbAddressList" */ '../components/AddressList')
    ),
    basket: dynamic(() => import(/* webpackChunkName: "blazePbBasket" */ '../components/Basket')),
    basketcheckouttotals: dynamic(() =>
      import(/* webpackChunkName: "blazePbBasketTotals" */ '../components/BasketCheckoutTotals')
    ),
    cartmessages: dynamic(() =>
      import(/* webpackChunkName: "blazePbCartMessages" */ '../components/CartMessagesComponent')
    ),
    checkoutbutton: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutButton" */ '../components/CheckoutButton')
    ),
    checkoutaddress: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutAddress" */ '../components/CheckoutAddress')
    ),
    checkoutbilling: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutBillsing" */ '../components/CheckoutBilling')
    ),
    discounts: dynamic(() =>
      import(/* webpackChunkName: "blazePbDiscounts" */ '../components/Discounts')
    ),
    ordernumber: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutOrderNumber" */ '../components/OrderNumber')
    ),
    orderreview: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutOrderReview" */ '../components/OrderReview')
    ),
    checkoutreview: dynamic(() =>
      import(/* webpackChunkName: "blazePbCheckoutReview" */ '../components/CheckoutReview')
    ),
    currency: dynamic(() =>
      import(/* webpackChunkName: "blazePbCurrency" */ '../components/Currency')
    ),
    flyoutbasket: dynamic(() =>
      import(/* webpackChunkName: "blazePbFlyOutBasket" */ '../components/FlyOutBasket')
    ),
    variants: dynamic(() =>
      import(/* webpackChunkName: "blazePbVariants" */ '../components/Variants')
    )
  };

  Object.entries(components).forEach(([key, component]) => {
    addComponent({
      key: `${COMPONENT_PREFIX}${key}`,
      component
    });
  });
};

export default addPageBuilderComponents;
